import { render, staticRenderFns } from "./AdminTravellerView.vue?vue&type=template&id=1febd5ea&scoped=true&"
import script from "./AdminTravellerView.vue?vue&type=script&lang=js&"
export * from "./AdminTravellerView.vue?vue&type=script&lang=js&"
import style0 from "./AdminTravellerView.vue?vue&type=style&index=0&id=1febd5ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febd5ea",
  null
  
)

export default component.exports